var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBankJcbSquare = function SvgBankJcbSquare(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_1389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 17.7579C24 19.8117 22.3276 21.4841 20.2738 21.4841H0V6.72616C0 4.67237 1.67237 3 3.72616 3H24V17.7579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3986 13.9731H18.9389C18.9829 13.9731 19.0856 13.9584 19.1296 13.9584C19.423 13.8998 19.6724 13.6357 19.6724 13.2689C19.6724 12.9169 19.423 12.6528 19.1296 12.5795C19.0856 12.5648 18.9976 12.5648 18.9389 12.5648H17.3986V13.9731Z",
    fill: "url(#paint0_linear_448_1389)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7628 4.24694C17.2959 4.24694 16.0929 5.4352 16.0929 6.91687V9.68948H19.8631C19.9511 9.68948 20.0538 9.68948 20.1271 9.70415C20.978 9.74816 21.6088 10.1883 21.6088 10.9511C21.6088 11.5526 21.1834 12.066 20.3912 12.1687V12.198C21.2567 12.2567 21.9169 12.7408 21.9169 13.489C21.9169 14.2958 21.1834 14.824 20.2152 14.824H16.0782V20.2518H19.9951C21.4621 20.2518 22.665 19.0636 22.665 17.5819V4.24694H18.7628Z",
    fill: "url(#paint1_linear_448_1389)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4817 11.1271C19.4817 10.7751 19.2323 10.5403 18.9389 10.4963C18.9096 10.4963 18.8362 10.4817 18.7922 10.4817H17.3986V11.7726H18.7922C18.8362 11.7726 18.9242 11.7726 18.9389 11.7579C19.2323 11.7139 19.4817 11.4792 19.4817 11.1271Z",
    fill: "url(#paint2_linear_448_1389)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00491 4.24694C2.53792 4.24694 1.33498 5.4352 1.33498 6.91687V13.5037C2.08315 13.8704 2.86065 14.1051 3.63816 14.1051C4.56237 14.1051 5.06114 13.5477 5.06114 12.7848V9.67481H7.34965V12.7702C7.34965 13.9731 6.60149 14.956 4.06359 14.956C2.52325 14.956 1.32031 14.6186 1.32031 14.6186V20.2372H5.23718C6.70418 20.2372 7.90711 19.0489 7.90711 17.5672V4.24694H4.00491Z",
    fill: "url(#paint3_linear_448_1389)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3839 4.24694C9.91686 4.24694 8.71393 5.4352 8.71393 6.91687V10.4083C9.38874 9.83618 10.5623 9.46943 12.4548 9.55745C13.467 9.60146 14.5526 9.88019 14.5526 9.88019V11.0098C14.0098 10.731 13.3643 10.4817 12.5281 10.423C11.0905 10.3203 10.2249 11.0244 10.2249 12.2567C10.2249 13.5037 11.0905 14.2078 12.5281 14.0905C13.3643 14.0318 14.0098 13.7677 14.5526 13.5037V14.6332C14.5526 14.6332 13.4817 14.912 12.4548 14.956C10.5623 15.044 9.38874 14.6773 8.71393 14.1051V20.2665H12.6308C14.0978 20.2665 15.3007 19.0782 15.3007 17.5966V4.24694H11.3839Z",
    fill: "url(#paint4_linear_448_1389)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_1389",
    x1: 16.0905,
    y1: 13.2707,
    x2: 22.6828,
    y2: 13.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_448_1389",
    x1: 16.0903,
    y1: 12.243,
    x2: 22.6831,
    y2: 12.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_448_1389",
    x1: 16.0903,
    y1: 11.1253,
    x2: 22.6829,
    y2: 11.1253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_448_1389",
    x1: 1.33188,
    y1: 12.243,
    x2: 8.02621,
    y2: 12.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_448_1389",
    x1: 8.676,
    y1: 12.243,
    x2: 15.1777,
    y2: 12.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_1389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18.5625,
    fill: "white",
    transform: "translate(0 3)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBankJcbSquare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bank-jcb-square.3f3446918c0d8547e5a0836d1e727c16.svg";